module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-600.woff2?aa4405ed937295296cf8510f437628e0";